import React, { useState } from 'react';

const Search = ({ onClose, isMobile = false }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchQuery.trim()) return;

        setIsSearching(true);

        // Simulate search results with a delay
        setTimeout(() => {
            const mockResults = [
                {
                    title: `Results for "${searchQuery}" - GOOD VIBES* #ccfc Search`,
                    url: 'https://goodvibes.search/results',
                    description: `Find the best results for "${searchQuery}" with our positive search engine.`
                },
                {
                    title: `How to stay positive while searching for "${searchQuery}"`,
                    url: 'https://goodvibes.search/positivity',
                    description: 'Learn how to maintain good vibes during your search journey.'
                },
                {
                    title: `Community discussions about "${searchQuery}"`,
                    url: 'https://goodvibes.search/community',
                    description: 'Join our community of positive thinkers discussing this topic.'
                }
            ];
            setSearchResults(mockResults);
            setIsSearching(false);
        }, 1000);
    };

    const handleClose = () => {
        setSearchQuery('');
        setSearchResults([]);
        onClose();
    };

    return (
        <div className="window-overlay">
            <div
                className={`win98-window search-window ${isMobile ? 'mobile-fullscreen-window' : ''}`}
                style={isMobile ? {
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    width: '100vw',
                    height: '100vh',
                    transform: 'none'
                } : {
                    position: 'absolute',
                    left: 100,
                    top: 50,
                    width: 700,
                    height: 500
                }}
            >
                <div className="window-titlebar">
                    <div className="window-title">Internet Explorer - GOOD VIBES* #ccfc Search Engine</div>
                    <div className="window-controls">
                        <button className="minimize-btn">_</button>
                        <button className="maximize-btn">□</button>
                        <button className="close-btn" onClick={handleClose}>×</button>
                    </div>
                </div>

                <div className="window-content">
                    <div className="win98-content">
                        <div className="search-container">
                            {/* Good Vibes Logo */}
                            <div className="search-logo">
                                <div className="logo-text">GOOD VIBES* #ccfc</div>
                                <div className="logo-subtitle">Search Engine</div>
                            </div>

                            {/* Search Form */}
                            <form className="search-form" onSubmit={handleSearch}>
                                <div className="search-input-container">
                                    <input
                                        type="text"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        placeholder="Search for good vibes..."
                                        className="search-input"
                                        autoFocus
                                    />
                                    <button type="submit" className="search-button" disabled={isSearching}>
                                        {isSearching ? 'Searching...' : 'Search'}
                                    </button>
                                </div>
                            </form>

                            {/* Search Results */}
                            {searchResults.length > 0 && (
                                <div className="search-results">
                                    <div className="results-header">
                                        <p>About {searchResults.length} results (0.42 seconds)</p>
                                    </div>
                                    {searchResults.map((result, index) => (
                                        <div key={index} className="search-result">
                                            <h3 className="result-title">
                                                <a href="#" onClick={(e) => e.preventDefault()}>
                                                    {result.title}
                                                </a>
                                            </h3>
                                            <p className="result-url">{result.url}</p>
                                            <p className="result-description">{result.description}</p>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Welcome Message */}
                            {searchResults.length === 0 && !isSearching && (
                                <div className="welcome-message">
                                    <h2>Welcome to GOOD VIBES* #ccfc Search Engine! 🌟</h2>
                                    <p>Search for anything with positive energy and good vibes.</p>
                                    <div className="feature-list">
                                        <div className="feature-item">✨ Positive search results</div>
                                        <div className="feature-item">🌈 Community-driven content</div>
                                        <div className="feature-item">💖 Uplifting information</div>
                                    </div>
                                </div>
                            )}

                            {/* Loading State */}
                            {isSearching && (
                                <div className="loading-container">
                                    <div className="loading-spinner"></div>
                                    <p>Searching for good vibes...</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Search;
